import { getIntegerFilterValue } from "./integer-filter-value";

export type MonetaryFilterValueItem = number | undefined;

export const getMonetaryFilterValue = ({
  column,
  min: _min,
  max: _max,
}: {
  column: string;
  min: MonetaryFilterValueItem;
  max: MonetaryFilterValueItem;
}) => {
  return getIntegerFilterValue({ column, min: _min, max: _max });
};
